import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewportService } from 'app/core/services/viewport.service';

@Component({
  selector: 'fts-order-notification-upsell-button',
  templateUrl: './order-notification-upsell-button.component.html',
  styleUrls: ['./order-notification-upsell-button.component.scss'],
})
export class OrderNotificationUpsellButtonComponent {
  @Input()
  btnLabel: string;
  @Input()
  loadingSubscription: Subscription;

  constructor(public viewportService: ViewportService) {}
}
